/**
 * 4Talks - Filter controls on /talks
 * Show/hide
 * Fire form submits/fetches updated content
 *
 * @author Matt Haynes
 * @package Joi Polloi
 *
 */

const talksFilters = () => {
    const talksFiltersContainer = document.getElementById('talksFilters');
    if (!talksFiltersContainer) return;

    const filterButtons = Array.from(document.querySelectorAll('.talks__title--button'));
    const filterLists = Array.from(document.querySelectorAll('.talks__filter'));

    filterButtons.forEach(button => {
        button.addEventListener('click', () => {
            const buttonFilter = button.dataset.filter;

            filterLists.forEach(filter => {
                const filterData = filter.dataset.filters;

                if (filterData === buttonFilter && filter.parentElement.classList.contains('active')) {
                    filter.parentElement.classList.remove('active');
                } else if (filterData === buttonFilter) {
                    filter.parentElement.classList.add('active');
                } else {
                    filter.parentElement.classList.remove('active');
                }
            });
        });
    });

    const filterRadios = Array.from(document.querySelectorAll('.filter-radio'));

    filterRadios.forEach(radio => {
        const currentURL = window.location.href;
        // eslint-disable-next-line compat/compat
        const params = new URL(currentURL).searchParams;
        let category = params.get('category');
        let sortby = params.get('sortby');

        if (sortby === radio.dataset.sortby) {
            const theRadio = radio;
            theRadio.checked = true;
        }

        if (category === radio.dataset.category) {
            const theRadio = radio;
            theRadio.checked = true;
        }

        radio.addEventListener('change', () => {
            let dataToFilterBy = {};

            if (radio.dataset.category) {
                dataToFilterBy = {
                    type: 'category',
                    value: radio.dataset.category,
                };
            } else {
                dataToFilterBy = {
                    type: 'sortby',
                    value: radio.dataset.sortby,
                };
            }

            category = dataToFilterBy.type === 'category' ? dataToFilterBy.value : params.get('category');
            sortby = dataToFilterBy.type === 'sortby' ? dataToFilterBy.value : params.get('sortby');

            const baseURL = window.location.origin + window.location.pathname;
            const newURL = `${baseURL}?${category ? `category=${category}&` : ''}${sortby ? `sortby=${sortby}` : ''}`;
            window.location.href = newURL;
        });
    });
};

export default talksFilters;
